import { render } from "./PostCommentForm.vue?vue&type=template&id=e0c2b976"
import script from "./PostCommentForm.vue?vue&type=script&lang=js"
export * from "./PostCommentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__